import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class ServiceChangeRequestReviewEffects {


  constructor(private actions$: Actions) {}
}
